import { render, staticRenderFns } from "./offerwall-down.vue?vue&type=template&id=3d3abb54&"
import script from "./offerwall-down.vue?vue&type=script&lang=js&"
export * from "./offerwall-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports